import { createRoute, lazyRouteComponent, redirect } from "@tanstack/solid-router";
import { rootRoute } from "@/routes/__root";
import { isDuoEnabled } from "@/lib/p2p/signaling-availability";

/**
 * Duo route — **NOT registered** while the feature is off.
 *
 * `router.ts` only adds it to the tree if `isDuoEnabled()`, so today `/games/duo` falls into
 * the "page not found" screen with its CTA to the home: no dead UI and no
 * button leading to an error.
 *
 * Two things this file must keep doing if it ever returns to the tree:
 *
 *   · **`lazyRouteComponent`**, not a static import. It is what keeps `duo-game.tsx` and
 *     `lib/p2p/*` (WebRTC + signaling client) OUT of the main bundle: with the
 *     feature off that chunk is never requested — zero weight and zero network.
 *   · **`beforeLoad`** that returns to the home. Registering the route and trusting that nobody
 *     types it is not enough: it is addressable (deep link, history, a saved link).
 */
export const duoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/games/duo",
  beforeLoad: () => {
    if (!isDuoEnabled()) {
      throw redirect({ to: "/" });
    }
  },
  component: lazyRouteComponent(() => import("@/features/games/duo-page")),
});
